import {Injectable} from '@angular/core';
import {AuthHttpService} from "./auth-http.service";
import {FinalLensRequest} from "../model/inspection/inspection.model";
import {Observable} from "rxjs";
import {optimistic} from "./common-http.service";

@Injectable({
  providedIn: 'root'
})
export class InspectionApiService {

  constructor(
    private authHttp: AuthHttpService
  ) { }

  inspectFinalLens(request: Array<FinalLensRequest>): Observable<Array<string>> {
    return this.authHttp.post<Array<string>>("/inspection/final_lens", request).pipe(optimistic);
  }
}
